import { loadStripe } from '@stripe/stripe-js';

if (!import.meta.env.REACT_APP_STRIPE_PUBLIC_KEY) {
    throw new Error('Stripe public key is not defined in config.');
}

const stripePromise = loadStripe(import.meta.env.REACT_APP_STRIPE_PUBLIC_KEY);

// Opciones de <Elements>: los campos de la tarjeta y los mensajes de Stripe (tarjeta rechazada, 3D Secure...) siempre en
// español, sin depender del idioma del navegador.
export const stripeElementsOptions = { locale: 'es' as const };

export default stripePromise;